import { useFrame, useThree } from "@react-three/fiber";
import { MathUtils } from "three";
import { Instances, Instance, useTexture } from "@react-three/drei";
import { useEffect, useMemo, useRef } from "react";
import steamTexturePath from "./flame_04.png";

import * as THREE from "three";
import { Vector3 } from "three";
import { useState } from "react";

export const SteamParticelsBAS = ({ ...props }) => {
  const groupRef = useRef();

  useMemo(() => {}, []);

  return <group {...props} ref={groupRef}></group>;
};

const SteamParticlesInstances = ({
  particleCount = 50,
  lifetime = 5,
  active,
  rotationSpeed = 0,
  // XWIDTH = 6,
  // ZWIDTH = 15,
  // HEIGHT = 25,
  ...props
}) => {
  const ref = useRef();
  const groupRef = useRef();
  const { clock } = useThree();

  // const [startTime, setstartTime] = useState(0);
  // const [stopTime, setstopTime] = useState(0);
  const startTime = useRef(0);
  const stopTime = useRef(0);

  const [_active, _setActive] = useState(false);

  useEffect(() => {
    if (active) {
      startTime.current = clock.elapsedTime;
      _setActive(true);
      // console.log("START");
      // setstartTime(clock.elapsedTime);
    } else {
      stopTime.current = clock.elapsedTime;
      _setActive(false);
      // console.log("STOP");
      // setstopTime(clock.elapsedTime);
    }
  }, [active]);

  const steamTexture = useTexture(steamTexturePath);

  const particles = useMemo(() => {
    return Array.from({ length: particleCount }, () => ({
      factor: MathUtils.randInt(20, 100),
      speed: MathUtils.randFloat(0.05, 0.1),
      delay: MathUtils.randFloat(0.1, lifetime - 0.1),
      direction: new Vector3(
        MathUtils.randFloat(-0.025, 0.025),
        MathUtils.randFloat(0.1, 0.2),
        MathUtils.randFloat(-0.025, 0.025),
      ),
      // speed: MathUtils.randFloat(10, 10000),
      // xFactor: MathUtils.randFloatSpread(XWIDTH),
      // yFactor: MathUtils.randFloatSpread(HEIGHT) + 10,
      // zFactor: MathUtils.randFloatSpread(ZWIDTH),
    }));
  }, []);

  useFrame(() => {
    groupRef.current.rotation.y += rotationSpeed;
  });

  return (
    <group {...props} ref={groupRef}>
      <Instances limit={particles.length} ref={ref} castShadow receiveShadow position={[0, 0, 0]} frustumCulled={false}>
        {/* <sphereGeometry args={[1, 32, 32]} /> */}
        {/* <cylinderBufferGeometry args={[0.0075, 0.0075, 0.2, 3]} /> */}
        <planeGeometry args={[0.3, 0.3, 1, 1]} />
        <meshBasicMaterial
          color="#f0f0f0"
          transparent
          opacity={0.8}
          blending={THREE.AdditiveBlending}
          map={steamTexture}
          depthTest={true}
          depthWrite={false}
          side={THREE.DoubleSide}
        />
        {particles.map((data, i) => (
          <SteamParticle key={i} {...data} lifetime={lifetime} startTime={startTime} stopTime={stopTime} active={_active} />
        ))}
      </Instances>
    </group>
  );
};

const SteamParticle = ({ delay, lifetime, speed, direction, startTime, stopTime, active }) => {
  const ref = useRef();

  const currentProgress = useRef(1);

  const randomRotation = useMemo(() => {
    return [
      MathUtils.degToRad(MathUtils.randFloat(0, 360)),
      MathUtils.degToRad(MathUtils.randFloat(0, 360)),
      MathUtils.degToRad(MathUtils.randFloat(0, 360)),
    ];
  }, []);

  useFrame(({ clock }) => {
    let progress = ((clock.elapsedTime - (startTime.current + delay)) % lifetime) / lifetime;

    if (active) {
      // currentProgress.current = Math.max(progress, currentProgress.current);
      currentProgress.current = Math.max(progress, 0);
    } else {
      currentProgress.current = Math.max(progress, currentProgress.current);
    }

    ref.current.scale.set(currentProgress.current, currentProgress.current, currentProgress.current);

    ref.current.color.r = 1 - currentProgress.current;
    ref.current.color.g = 1 - currentProgress.current;
    ref.current.color.b = 1 - currentProgress.current;

    ref.current.position.set(
      direction.x * currentProgress.current,
      direction.y * currentProgress.current,
      direction.z * currentProgress.current,
    );
  });

  return <Instance ref={ref} position={[0, 0, 0]} rotation={randomRotation} scale={0} />;
};

const RainDrop = ({ factor, speed, xFactor, yFactor, zFactor }) => {
  const ref = useRef();
  useFrame((state) => {
    // const t = state.clock.elapsedTime * (speed / 2);
    // console.log(t);
    let y = ref.current.position.y + 0.25 * speed;
    if (y < -15) {
      y = yFactor;
    }
    ref.current.position.set(xFactor, y, zFactor);
  });
  return <Instance ref={ref} position={[xFactor, yFactor, zFactor]} />;
};

export default SteamParticlesInstances;
